export const APP = 'APP';
export const PROFILE = 'PROFILE';
export const THEME = 'THEME';
export const MODULE = 'MODULE';
// TODO: Confirm with backend that this is the correct review type for initial agent feedback
export const AGENT = 'AGENT';
export const ACADEMY_COURSE = 'ACADEMY_COURSE';
export const ACADEMY_LESSON = 'ACADEMY_LESSON';
export const ACADEMY_ON_THE_GO = 'ACADEMY_ON_THE_GO';